import { SVGProps } from 'react';
interface SVGRProps {
    title?: string;
    titleId?: string;
}
export const IconCoin = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={20}
        height={20}
        fill="none"
        viewBox="0 0 24 24"
        display="block"
        aria-labelledby={titleId}
        {...props}
    >
        {title ? <title id={titleId}>{title}</title> : null}
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12m11-5a1 1 0 0 0-2 0 3 3 0 1 0 0 6v2h-.034a1 1 0 0 1-.9-.5 1 1 0 0 0-1.732 1A3 3 0 0 0 11 17a1 1 0 0 0 2 0 3 3 0 0 0 0-6V9h.034a1 1 0 0 1 .9.5 1 1 0 0 0 1.732-1A3 3 0 0 0 13 7m0 6v2a1 1 0 0 0 0-2m-2-2V9a1 1 0 1 0 0 2"
            clipRule="evenodd"
        />
    </svg>
);
